var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenovationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#274BF1",
    strokeWidth: 1,
    d: "m15.55 6.905.307-.307c.285-.285.428-.428.514-.576.232-.403.232-.9 0-1.302-.086-.149-.229-.291-.514-.577-.286-.285-.428-.428-.577-.513a1.302 1.302 0 0 0-1.302 0c-.148.085-.29.228-.576.513l-.307.307m-3.682 8.592L4.81 17.645c-.286.285-.428.428-.577.514-.402.233-.899.233-1.302 0-.148-.086-.29-.229-.576-.514-.285-.285-.428-.428-.514-.576a1.302 1.302 0 0 1 0-1.302c.086-.149.229-.291.514-.577l4.603-4.603m-.614-.613 3.682 3.682c1.447 1.447 2.17 2.17 3.069 2.17s1.622-.723 3.069-2.17c1.446-1.447 2.17-2.17 2.17-3.069 0-.898-.724-1.622-2.17-3.068L12.48 3.837c-1.446-1.447-2.17-2.17-3.068-2.17-.9 0-1.622.723-3.069 2.17-1.446 1.446-2.17 2.17-2.17 3.068 0 .899.724 1.622 2.17 3.069Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenovationIcon);
export default __webpack_public_path__ + "static/media/RenovationIcon.a1d453687763f5215f92b62822485010.svg";
export { ForwardRef as ReactComponent };